import { IDataLayer, IDataLayerType, IDataLayerZone, IGeometry, IGeometryInstance, selectMany } from "../../omnia"
import { cleanupPolygon } from "../../utils"
import { Class, IMapTopologyGeometry, IMapTopologyService, SourceZone } from "./types"

export function createTargetLayer(sourceLayer: Partial<IDataLayer>, zones: { geometry: IMapTopologyGeometry, cls: Class }[], topo: IMapTopologyService, type: IDataLayerType) {

    zones = zones
        .map(z => ({
            ...z,
            geometry: cleanupPolygon(topo.cleanupInteriorRings(z.geometry, 1).getOpenLayersPolygon())
        }))
        .filter(z => z.geometry)
        .map(z => ({
            ...z,
            geometry: topo.getGeometry(z.geometry)
        }))

    const sortedZones = zones
        .map(z => ({
            ...z,
            area: topo.getArea(z.geometry)
        }))
        .sort((a, b) => b.area - a.area)

    const targetZones = sortedZones.map((z, index) => ({
        DataLayerZoneId: (index + 1),
        LayerId: 1,
        Geometry: <IGeometry>{
            Geometry: <IGeometryInstance>{
                WellKnownText: z.geometry.getWKT(),
                CoordinateSystemId: 3857
            }
        },
        Value: z.cls.targetValue,
        Number: (index + 1)
    }) as IDataLayerZone)


    const zoneMap = sortedZones.map((z, index) => ({
        id: index + 1,
        zone: targetZones[index],
        cls: z.cls
    }))

    const layer = {
        ...sourceLayer,
        DataLayerId: 1,
        Type: type,
        TypeId: type.TypeId,
        Zones: targetZones,
    } as IDataLayer

    return { layer, zones: zoneMap }

}

export function simplify(zones: SourceZone[], classes: Class[], topo: IMapTopologyService) {

    const groups = groupZones(zones, classes)

    const results = selectMany(groups.map(g => {

        const zones = g.zones.map(z => topo.getGeometry(z.geometry))

        let merged = mergeGroupZones(zones, topo) || []

        merged = selectMany(merged.map(m => topo.geometryCollectionToArray(m)))

        return merged.map(m => ({
            geometry: m,
            cls: g.cls
        }))

    }))

    return results

}


function mergeGroupZones(zones: IMapTopologyGeometry[], topo: IMapTopologyService): IMapTopologyGeometry[] {

    function merge(zones: IMapTopologyGeometry[]) {

        if (!zones.length) {
            return []
        }

        let g = topo.getGeometry(zones[0])
        let remaining = [] as IMapTopologyGeometry[]

        zones.slice(1).forEach(n => {

            let merged = false

            if (topo.intersects(g, n)) {

                const r = topo.union([g, n])

                if (r && r.isValid() && (r.getDimension() == 2)) {
                    g = r
                    merged = true
                }
            }

            if (!merged) {
                remaining.push(n)
            }

        })

        return [g].concat(remaining.length ? merge(remaining) : [])

    }

    const result = merge(zones)

    return (result.length == zones.length)
        ? result
        : merge(result)

}

export function groupZones(zones: SourceZone[], classes: Class[]) {

    const last = (classes.length - 1)

    zones = zones.sort((a, b) => b.area - a.area)

    const groups = classes.map((c, index) => ({
        cls: c,
        zones: zones.filter(z =>
            ((z.value >= c.min) || ((index == 0) && (z.value <= c.min)))
            && ((z.value < c.max) || ((index == last) && (z.value >= c.max)))
        )
    }))

    return groups

}
